<template>
  <div class="container">
    <div class="row g">
      <div v-if="dataProvider" class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>{{ $t('data_providers.title') }}</h3>
            <button class="btn btn-primary" @click="openEditOffcanvas">{{ $t('data_providers.edit') }}</button>
          </div>
          <hr/>
          <div class="row mb-3">
            <div class="col-12 col-md-3 mb-2">
              <label class="text-muted mb-2">{{ $t('data_providers.name') }}</label>
              <div class="fs-5">{{ dataProvider.name }}</div>
            </div>
            <div class="col-12 col-md-3 mb-2">
              <label class="text-muted mb-2">{{ $t('data_providers.status') }}</label>
              <div class="fs-5">{{ $t(dataProvider.status.description) }}</div>
            </div>
            <div class="col-6">
              <label class="text-muted mb-2">{{ $t('data_providers.description') }}</label>
              <div class="fs-5">{{ dataProvider.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row g">
      <div v-if="dataProvider" class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>{{ $t('tokens.title') }}</h3>
          </div>
          <hr/>
          <TokenManager :dataProviderId="dataProvider.id" />
        </div>
      </div>
    </div>
  </div>

  <DataProviderEditOffcanvas :dataProvider="dataProvider" @update="fetch"/>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import {getDataProvider} from '../../../api/admin/DataProviderApi';
import useOffcanvas from '../../../composables/useOffcanvas';
import TokenManager from '../../../components/TokenManager.vue';
import DataProviderEditOffcanvas from './DataProviderEditOffcanvas.vue';

const {openOffcanvas: openEditOffcanvas} = useOffcanvas('dataProviderEditOffcanvas');

const route = useRoute();

const dataProvider = ref();

onMounted(async () => {
  await fetch();
});

/**
 * Fetch data provider details
 * @returns {Promise<void>}
 */
const fetch = async () => {
  dataProvider.value = await getDataProvider(route.params.id);
};
</script>